import { render, staticRenderFns } from "./LibraryBooks.vue?vue&type=template&id=b31900f0&scoped=true&"
import script from "./LibraryBooks.vue?vue&type=script&lang=js&"
export * from "./LibraryBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31900f0",
  null
  
)

export default component.exports